<style scoped="scoped" lang="scss">
.gongdan_select_title {
  line-height: 24px;
  font-size: 16px;
  color: #303133;
  margin-bottom: 10px;
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <div class="gongdan_select_title">{{$t('yibanggongdan')}}</div>
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"  @finishRemove="afterRemoveBind"
        getUrl="/web/inspection/record/bind/wo/page" getKey="rows" :columns="bindedcolumns" style="height: 50%; width: 100%; margin-bottom: -80px">
      <!-- 搜索框插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button v-if="!scope.row.main" type="text" class="font-color-danger"
                @click="yt.remove(scope.row,'/web/inspection/record/bind/wo/delete')">{{$t('shanchu')}}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <div>
      <div class="gongdan_select_title">{{$t('gongdanxuanze')}}</div>
      <work_order :detailsItem="$attrs.detailsItem"></work_order>
    </div>
  </div>
</template>
<script type="text/javascript">
import work_order from '@@/pages/web/quality_management/record_first/work_order'

export default {
  name: 'web_quality_management_record_first_bind_wo',
  components: {
    work_order
  },
  data() {
    return {

      show: false,
      bindedcolumns: [{
        label: 'shengchangongdanhao',
        prop: 'wo.no'
      }, {
        label: 'ERPgongdanhao',
        prop: 'wo.erpNo',
      }, {
        label: 'caozuo',
        type: 'slot',
        width: 250,
        fixed: 'right'
      }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        inspectionRecordId: this.$attrs.detailsItem.id,
      }
      this.yt.get(1);
      this.utils.event_hub.$on('INSPECTION_RECORD_BIND_WO_REFRESH', () => {
        this.yt.get(1);
      })
    }, 300)
  },

  destroyed() {
    this.utils.event_hub.$off('INSPECTION_RECORD_BIND_WO_WORK_ORDER_REFRESH');
    clearInterval(this.timmer)
    clearInterval(this.interval)
  },

  methods: {

    afterRemoveBind() {
      // 在这里执行 yt.remove 方法完成后的操作
      // 例如触发事件或其他逻辑
      this.utils.event_hub.$emit('INSPECTION_RECORD_BIND_WO_WORK_ORDER_REFRESH');
    },
  }
};
</script>
